import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App";
import "./index.css";

const PUBLISHABLE_KEY = import.meta.env["VITE_CLERK_PUBLISHABLE_KEY"] as
  | string
  | undefined;

if (!PUBLISHABLE_KEY) {
  // Loud failure so a missing key in dev is obvious instead of producing
  // a broken Clerk session silently.
  // eslint-disable-next-line no-console
  console.error(
    "VITE_CLERK_PUBLISHABLE_KEY is not set. Auth UI will not render."
  );
}

const root = document.getElementById("root");
if (!root) throw new Error("#root element not found in index.html");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    {PUBLISHABLE_KEY ? (
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <App />
      </ClerkProvider>
    ) : (
      <div style={{ padding: 24, fontFamily: "system-ui" }}>
        <h1>Configuration error</h1>
        <p>
          <code>VITE_CLERK_PUBLISHABLE_KEY</code> is not set. Add it to the
          environment and reload.
        </p>
      </div>
    )}
  </React.StrictMode>
);
